import React, { useEffect, useState } from 'react';
// Icons
import SpeakerIcon from '@mui/icons-material/Speaker';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';

// Containers
import { HorizontalStack, SmartContainer, Stack, Surface } from '../../../styles/Containers';
import { StyledImg, StyledP } from '../../../styles/StyledHTML';
import { MediaImage, mediaPath, MediaVideo, useMediaAsset } from '../../../modules/Media/MediaUtils';
import { loadAsset } from './redux/assets.actions';
import { StyledImagePlaceholder } from '../../../styles/Containers';
import placeholderImage from '../../../assets/placeholder-square.jpg';
import { useAnimatedFadeIn } from '../../services/CaptureCollabService';
import { animated } from 'react-spring';
import { Theme } from '../../../styles/Theme';
import styled, { css } from 'styled-components';
import { Like } from '../UserEngagement/Like';
import { Save } from '../UserEngagement/Save';
import { AssetDownloadButton } from './AssetDownloadButton';
import { FullAssets } from './redux/assets.selectors';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { IconAudio, IconEdit, IconFile, IconPhoto, IconPlay } from '../../Icons';

import { setGlobalStorage, getGlobalStorage } from '../../services/CaptureCollabService';
import { MediaCard } from '../../../modules/Media/MediaCard';


export const useAsset = ({ id, model }) => {


    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const fullAssets = FullAssets();


    const load = async (id) => {
        if (!id) return;

        const g = getGlobalStorage(id);

        if (g) {
            setItem(g);
            return;
        }

        setLoading(true);
        const res = await loadAsset(id);
        if (res.status === 'success') {
            setItem(res.data);
            setGlobalStorage(id, res.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }


    useEffect(() => {
        if (item && item.id === id) return;

        load(id); // Load the Guide
    }, [id])


    useEffect(() => {
        if (!model) return;
        if (!model?.full) {
            setItem(model);
        }
        else if (model?.full?.id) {
            setItem(model.full);
        }
        else {
            // Shhhh
        }
    }, [model]);


    return {
        assetLoading: loading,
        asset: item,
    }
}

export const useAssetMedia = ({ args = null }) => {
    const [assetId, setAssetId] = useState(null);
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const { setMediaId, assetPath } = useMediaAsset({ args });

    const loadTheAsset = async (id) => {
        if (!id) return;
        const g = getGlobalStorage(id);
        if (g) {
            setItem(g);
            return;
        }
        setLoading(true);
        const res = await loadAsset(id);
        if (res.status === 'success') {
            setItem(res.data);
            setGlobalStorage(id, res.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!assetId) return;
        loadTheAsset(assetId);
    }, [assetId]);

    useEffect(() => {
        if (!item) return;
        if (item?.id === assetId) {
            setMediaId(item?.meta?.MediaId);
        } else {
            setAssetId(null);
        }
    }, [item])
    return {
        item,
        loading,
        setAssetId,
        assetPath
    }
}

const StyledAssetCard = styled(SmartContainer)`
    
    border-radius: ${Theme.radius};
    position: relative;
    transition: ${Theme.transition.one};
    min-height: 100px;
    
    // Rebrand
    /* background: ${Theme.colors.baseAlternate}; */
    /* border: 1px solid ${Theme.colors.dark}; */
   


    [data-asset-controls]{
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        transition: ${Theme.transition.one};
        opacity: 0;
        z-index: 2;
        /* padding: 0.5em; */
    }
    /* [data-media-image],
    video{
        object-fit: cover;
        height: 100%; 
    } */



    // Icons
    .MuiSvgIcon-root {
        color: white;
    }

    // Fade
    &:after {
        content:"";
        position: absolute;
        width: 100%;
        height: 25%;
        bottom: 0;
        left: 0;
        background: linear-gradient(0deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0) 100%);
        border-radius: ${Theme.radius};
        z-index: 1;
        transition: ${Theme.transition.one};
        opacity: 0;
        pointer-events: none;
        ${props => (props?.noControls === true) ? ' display: none;' : ''}
    }
    &:hover {
        &:after,
        [data-asset-controls] {
            opacity: 1;
        }
    }

    // VIDEO
    [data-play-icon] { display: none;}
    ${props => (props.type == 'video') ? css`
        /* opacity: 0.5; */
        /* background: black;
        padding-bottom: 2em;
        &:after {
            display: none;
        } */
        /* [data-asset-controls]{
            bottom: 4em;
        } */
    ` : ''}

    ${props => (props.type == 'video' && props.display != 'feed') ? css`
        background: black;
        padding-bottom: 2em;
        &:after {
            display: none;
        }
    ` : ''}

    ${props => (props.type == 'video' && props.display == 'feed') ? css`
        [data-play-icon]{
            display:flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: absolute;
            pointer-events: none;
            /* left: 50%;
            top: 50%;
            transform: translate(-50%,-50%); */
            width: 100%;
            height: 100%;
            background: radial-gradient(circle, rgba(0,0,0,0.25) 0%, rgba(0,212,255,0) 10%);
            /* background-color: rgba(0,0,0,0.20); */
            .MuiSvgIcon-root {
                width: 2em;
                height: 2em;
            }
            
        }
        display: flex;
            align-items: center;
    ` : ''}

    // Doc
    ${props => (props.type == 'doc') ? css`
            width: 100%;
            
            [data-file-icon] {
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,0.25);
                min-height: 250px;
            }
            [data-file-name]{
                padding: 1em;
                font-size: 10px;
            }
        `: ''}
   

    ${props => (props.enableSelect) ? css`
        &:after,
        [data-asset-controls] {
            opacity: 0;
        }
        &:hover {
            &:after,
            [data-asset-controls] {
                opacity: 0;
            }
            
        }
       
        ${props => (props.selected === true) ? css`
            opacity: 1;
            border: ${Theme.borderWidth} solid ${Theme.colors.dark};
            padding: 0.25em;
            border-radius: ${Theme.radius};
            img, video, [data-file-icon] {
                border-radius:  ${Theme.radiusSmall} !important;
            }
        ` : css` opacity: 0.35; `}
    ` : ''}


`

export const StyledPill = styled(SmartContainer)`
    background-color:white;
    color: black;
    font-size: 0.25em;
    padding: 0.25em 1.75em;
    border-radius: 3px;
    opacity:0.25;
    margin-bottom: 5px !important;
    display: block;
`
export const StyledPillContainer = styled(SmartContainer)`
    position: absolute;
    top: 1em;
    right: 1em;
    height: auto !important;
    font-size: 0.25em;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
`


export const AssetCard = ({
    display = null,
    item,
    enableSelect = false,
    selected = false,
    id = null,
    onClick,
    network = false,
    src,
    className,
    crop = false,
    noControls = false,
    showEdit = false,
    onEditClick = false,
    onMediaLoad = false
}) => {

    const { assetLoading, asset } = useAsset({ id, model: item });
    const { animatedProps } = useAnimatedFadeIn();

    const handleSelect = (s) => {
        if (!onClick) return;
        onClick(s);
    }

    const handleEditClick = (e) => {
        if (!onEditClick) return;
        e.stopPropagation();
        onEditClick(asset);
    }

    // Guard
    if (!asset) return (<StyledImg radius alt="Loading Placeholder Image" src={placeholderImage} />);

    const renderImage = () => {

        const mediaEventProps = {}

        if (onMediaLoad) {
            mediaEventProps.onLoad = onMediaLoad;
        }

        const bgFx = (display === 'feed') ? 'reelblur' : null;

        return (
            <animated.div style={{ ...animatedProps, borderRadius: Theme.radius }}>
                <StyledAssetCard
                    type="image"
                    enableSelect={enableSelect}
                    selected={selected}
                    onClick={() => handleSelect(asset)}
                    role='button'
                    noControls={noControls}
                >
                    {!noControls && (
                        <StyledPillContainer>
                            {asset?.meta?.raw === true && (<StyledPill>RAW</StyledPill>)}
                            {asset?.meta?.attachments?.length > 0 && (<StyledPill>ATTACHMENTS</StyledPill>)}
                        </StyledPillContainer>
                    )}
                    <MediaImage data-media-image radius backgroundEffect={bgFx} id={asset.meta.MediaId} crop={crop} network={network} {...mediaEventProps} />
                    {!noControls && (
                        <SmartContainer data-asset-controls flex align="center" justify="space-between">
                            <AssetDownloadButton asset={asset} />
                            <SmartContainer flex align="center" justify="flex-end">
                                {showEdit && (
                                    <StyledIconButton onClick={handleEditClick}>
                                        <IconEdit />
                                    </StyledIconButton>
                                )}
                                {/* <Like modelId={asset.id} modelType="Asset" />
                                <Save modelId={asset.id} modelType="Asset" /> */}
                            </SmartContainer>
                        </SmartContainer>
                    )}

                </StyledAssetCard>
            </animated.div>
        )
    }

    const renderVideo = () => {
        const showCoverPhoto = (display === 'feed' && (asset?.meta?.coverPhoto > 0));

        const mediaEventProps = {}

        if (onMediaLoad) {
            if (showCoverPhoto) {
                mediaEventProps.onLoad = onMediaLoad;
            } else {
                mediaEventProps.onLoadedData = onMediaLoad;
            }
        }

        const bgFx = (display === 'feed') ? 'reelblur' : null;

        return (
            <animated.div style={{ ...animatedProps, borderRadius: Theme.radius }}>
                <StyledAssetCard display={display} type="video" enableSelect={enableSelect} selected={selected} onClick={() => handleSelect(asset)}>
                    <SmartContainer data-play-icon><StyledIconButton><IconPlay /></StyledIconButton></SmartContainer>
                    {/* {display == 'feed' && (<SmartContainer onClick={() => handleSelect(asset)}><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /></SmartContainer>)} */}
                    {!showCoverPhoto && (
                        <MediaVideo controls={(display == 'feed') ? false : true} preload="metadata" data-media-video radius backgroundEffect={bgFx} id={asset.meta.MediaId} network={network} {...mediaEventProps} />
                    )}
                    {showCoverPhoto && (
                        <MediaImage data-media-image radius backgroundEffect={bgFx} id={asset.meta.coverPhoto} crop={crop} network={network} {...mediaEventProps} />
                    )}
                    {!noControls && (
                        <SmartContainer data-asset-controls flex align="center" justify="space-between">
                            <AssetDownloadButton asset={asset} />
                            <SmartContainer flex align="center" justify="flex-end">
                                {/* <Like modelId={asset.id} modelType="Asset" /> */}
                                {/* <Save modelId={asset.id} modelType="Asset" /> */}
                            </SmartContainer>
                        </SmartContainer>
                    )}

                </StyledAssetCard>
            </animated.div>
        )
    }

    const renderDoc = (type) => {

        return (
            <animated.div style={{ ...animatedProps, borderRadius: Theme.radius, width: '100%' }}>
                <StyledAssetCard type="doc" enableSelect={enableSelect} selected={selected} onClick={() => handleSelect(asset)}>
                    <SmartContainer data-file-icon flex align="center" justify="center" direction="column">
                        {type === 'doc' && (<IconFile />)}
                        {type === 'audio' && (<IconAudio />)}
                        {type === 'image' && (<IconPhoto />)}
                        <StyledP data-file-name small>{asset?.name}</StyledP>
                    </SmartContainer>
                    {!noControls && (
                        <SmartContainer data-asset-controls flex align="center" justify="space-between">
                            <AssetDownloadButton asset={asset} />
                            <SmartContainer flex align="center" justify="flex-end">
                                {showEdit && (
                                    <StyledIconButton onClick={handleEditClick}>
                                        <IconEdit />
                                    </StyledIconButton>
                                )}
                            </SmartContainer>
                        </SmartContainer>
                    )}
                </StyledAssetCard>
            </animated.div>
        )
    }

    // Render Preview
    const renderPreview = () => {



        if (asset?.mediaType === 'image' && asset?.meta?.mimetype?.indexOf('vnd.') > -1) return renderDoc('image');
        if (asset?.mediaType === 'image') return renderImage(asset);
        if (asset?.mediaType === 'video') return renderVideo(asset);
        if (asset?.mediaType === 'doc') return renderDoc('doc');
        if (asset?.mediaType === 'audio') return renderDoc('audio');

        // <StyledImagePlaceholder minHeight="150px" flex align="center" justify="center">{renderMediaIcon(item?.full?.mediaType, { network })}</StyledImagePlaceholder>
        // Render Icon
        return (
            <SmartContainer position="relative" onClick={() => handleSelect(asset)}>

                <SmartContainer position="absolute" bottom="0" left="0" width="100%" padding={2}>
                    <StyledP small>{asset?.title}</StyledP>
                </SmartContainer>
            </SmartContainer>
        )
    }

    return (
        <SmartContainer width="100%" clickable className={className}>
            <Stack width="100%">
                {renderPreview()}
            </Stack>
        </SmartContainer>
    )
}